import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { CookiePreferences, getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { FromDictionaryPipe, LanguageService } from '@teamfoster/sdk/dictionary-ngrx';
import { combineLatest, map, Observable, take, tap } from 'rxjs';
import { Profile } from 'src/app/auth/models';
import { getUser } from 'src/app/auth/store';
import {
  getAllRelatedEvents,
  getAllRelatedInitiatives,
  getAllRelatedStories,
  getRelatedStoriesLoaded,
  LoadRelatedInitiatives,
  LoadRelatedStories,
  getAllRelatedContent,
} from 'src/app/content/store';
import { Breadcrumb } from 'src/app/core/models';
import { Event } from 'src/app/events/models';
import { getSelectedContentLiked, getSelectedContentLikes, LikeContent, LoadLikes } from 'src/app/likes/store';
import { Story } from 'src/app/stories/models';
import { getAllStories } from 'src/app/stories/store';
import { Initiative } from '../../models';
import { getSelectedInitiative, LikeInitiative } from '../../store';
import { BaseContent } from 'src/app/content/models';

@Component({
  selector: 'app-initiative-detail',
  templateUrl: './initiative-detail.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InitiativeDetailComponent implements OnInit {
  initiative$!: Observable<Initiative>;

  relatedInitiatives$!: Observable<Initiative[]>;
  relatedEvents$!: Observable<Event[]>;
  relatedStories$!: Observable<Story[]>;
  relatedContent$!: Observable<BaseContent[]>;
  relatedStoriesLoaded$!: Observable<number>;
  user$!: Observable<Profile | undefined>;
  cookiePreferences$?: Observable<CookiePreferences | null>;

  likes$!: Observable<number>;
  liked$!: Observable<boolean>;

  hasRelated$!: Observable<boolean>;

  breadcrumbs$?: Observable<Breadcrumb[]>;

  previewPlaceholder$!: Observable<string>;

  private dict = new FromDictionaryPipe(this.lang);

  constructor(private store: Store, private activatedRoute: ActivatedRoute, private lang: LanguageService, private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.initiative$ = this.store.select(getSelectedInitiative);
    this.relatedInitiatives$ = this.store.select(getAllRelatedInitiatives);
    this.relatedEvents$ = this.store.select(getAllRelatedEvents);
    this.relatedStories$ = this.store.select(getAllRelatedStories);
    this.relatedStoriesLoaded$ = this.store.select(getRelatedStoriesLoaded);
    this.relatedContent$ = this.store.select(getAllRelatedContent);
    this.cookiePreferences$ = this.store.select(getCookiePreferences);
    this.likes$ = this.store.select(getSelectedContentLikes);
    this.liked$ = this.store.select(getSelectedContentLiked);

    this.hasRelated$ = combineLatest([this.relatedEvents$, this.relatedStories$]).pipe(
      map(([events, stories]) => {
        return !!(events.length || stories.length);
      })
    );

    this.user$ = this.store.select(getUser);
    this.previewPlaceholder$ = this.user$.pipe(
      map(a => (a?.roles.includes('Administrator') ? 'initiatief-niet-gepubliceerd-redactie' : 'initiatief-niet-gepubliceerd')),
      map(a => this.dict.transform(a))
    );

    this.initiative$.pipe(
      tap(a => {
        this.cd.detectChanges();
      })
    );

    this.breadcrumbs$ = this.initiative$.pipe(
      map(a => {
        return [
          {
            routerLink: ['/initiatieven'],
            title: this.dict.transform('breadcrumbs-initiatieven-overzicht-label'),
          },
          {
            title: a?.subtitle || a?.title,
          },
        ];
      })
    );
  }

  like(id: number) {
    this.store.dispatch(LikeContent({ id }));
  }
}
